import React from 'react';
import { TrendingDown, Sun, Wrench } from 'lucide-react';

const content = {
  heading: 'Energie curată. Economii imediate.',
  benefits: [
    { icon: TrendingDown, title: 'Costuri mai mici cu energia.', description: 'Cu un sistem fotovoltaic devii independent de prețurile în creștere. Economisești din prima lună.' },
    { icon: Sun, title: 'Independență energetică.', description: 'Produci și consumi propria energie. Reduci dependența de rețea și ai control total.' },
    { icon: Wrench, title: 'Întreținere minimă, performanță maximă.', description: 'Sistemele moderne necesită aproape zero întreținere și oferă eficiență constantă 25+ ani.' },
  ],
};

const WhyChoose: React.FC = () => {
  return (
    <section className="py-20 md:py-28">
      <div className="container mx-auto px-4 lg:px-8">
        <h2 className="text-3xl md:text-4xl lg:text-[2.75rem] font-bold leading-tight mb-16 max-w-xl">
          {content.heading}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-12">
          {content.benefits.map((benefit, index) => (
            <div key={index} className="space-y-4">
              <div className="w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center">
                <benefit.icon size={24} className="text-accent" />
              </div>
              <h3 className="text-xl font-semibold">{benefit.title}</h3>
              <p className="text-muted-foreground leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
